import styled from 'styled-components';
import { Section } from './Layout';

export const FAQSection = styled(Section)`
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  
  & > h2 {
    text-align: center;
  }
`;

export const FAQItem = styled.div`
  margin-bottom: 30px;
  text-align: center;
`;

export const FAQQuestion = styled.h4`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 10px;
  color: #1a1a1a;
  text-align: center;
`;

export const FAQAnswer = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
  text-align: center;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
`; 